import Circle from "./circle"

const EmptySlot = () => {
    return (
        <div>
            <Circle radius={5} borderColor="#212121" borderStyle="solid" backgroundColor="#FFFFFF" character="" />
        </div>
    )
}

export default EmptySlot;